export interface UsState {
  /** USPS abbreviation, sent to billing in the ACC segment */
  code: string;
  /** Full state name */
  description: string;
  /** Numeric state code used by CollaborateMD */
  stateCode: string;
}

export const usStates: UsState[] = [
  { code: 'AL', description: 'Alabama', stateCode: '1' },
  { code: 'AK', description: 'Alaska', stateCode: '2' },
  { code: 'AZ', description: 'Arizona', stateCode: '4' },
  { code: 'AR', description: 'Arkansas', stateCode: '5' },
  { code: 'CA', description: 'California', stateCode: '6' },
  { code: 'CO', description: 'Colorado', stateCode: '8' },
  { code: 'CT', description: 'Connecticut', stateCode: '9' },
  { code: 'DE', description: 'Delaware', stateCode: '10' },
  { code: 'DC', description: 'District of Columbia', stateCode: '11' },
  { code: 'FL', description: 'Florida', stateCode: '12' },
  { code: 'GA', description: 'Georgia', stateCode: '13' },
  { code: 'HI', description: 'Hawaii', stateCode: '15' },
  { code: 'ID', description: 'Idaho', stateCode: '16' },
  { code: 'IL', description: 'Illinois', stateCode: '17' },
  { code: 'IN', description: 'Indiana', stateCode: '18' },
  { code: 'IA', description: 'Iowa', stateCode: '19' },
  { code: 'KS', description: 'Kansas', stateCode: '20' },
  { code: 'KY', description: 'Kentucky', stateCode: '21' },
  { code: 'LA', description: 'Louisiana', stateCode: '22' },
  { code: 'ME', description: 'Maine', stateCode: '23' },
  { code: 'MD', description: 'Maryland', stateCode: '24' },
  { code: 'MA', description: 'Massachusetts', stateCode: '25' },
  { code: 'MI', description: 'Michigan', stateCode: '26' },
  { code: 'MN', description: 'Minnesota', stateCode: '27' },
  { code: 'MS', description: 'Mississippi', stateCode: '28' },
  { code: 'MO', description: 'Missouri', stateCode: '29' },
  { code: 'MT', description: 'Montana', stateCode: '30' },
  { code: 'NE', description: 'Nebraska', stateCode: '31' },
  { code: 'NV', description: 'Nevada', stateCode: '32' },
  { code: 'NH', description: 'New Hampshire', stateCode: '33' },
  { code: 'NJ', description: 'New Jersey', stateCode: '34' },
  { code: 'NM', description: 'New Mexico', stateCode: '35' },
  { code: 'NY', description: 'New York', stateCode: '36' },
  { code: 'NC', description: 'North Carolina', stateCode: '37' },
  { code: 'ND', description: 'North Dakota', stateCode: '38' },
  { code: 'OH', description: 'Ohio', stateCode: '39' },
  { code: 'OK', description: 'Oklahoma', stateCode: '40' },
  { code: 'OR', description: 'Oregon', stateCode: '41' },
  { code: 'PA', description: 'Pennsylvania', stateCode: '42' },
  { code: 'PR', description: 'Puerto Rico', stateCode: '72' },
  { code: 'RI', description: 'Rhode Island', stateCode: '44' },
  { code: 'SC', description: 'South Carolina', stateCode: '45' },
  { code: 'SD', description: 'South Dakota', stateCode: '46' },
  { code: 'TN', description: 'Tennessee', stateCode: '47' },
  { code: 'TX', description: 'Texas', stateCode: '48' },
  { code: 'UT', description: 'Utah', stateCode: '49' },
  { code: 'VT', description: 'Vermont', stateCode: '50' },
  { code: 'VA', description: 'Virginia', stateCode: '51' },
  { code: 'VI', description: 'Virgin Islands', stateCode: '78' },
  { code: 'WA', description: 'Washington', stateCode: '53' },
  { code: 'WV', description: 'West Virginia', stateCode: '54' },
  { code: 'WI', description: 'Wisconsin', stateCode: '55' },
  { code: 'WY', description: 'Wyoming', stateCode: '56' },
];

export const usStateLabel = (s: UsState) => (s ? `${s.code} - ${s.description}` : '');
